<div
  class="container-fluid py-4"
  [ngClass]="{
    'auctions-memorabid': isMemorabid,
    'auctions-marketplace': !isMemorabid
  }"
>
  <app-bid-box-header
    *ngIf="isMemorabid"
    [isGoldAuction]="true"
    [isSuggestedAuction]="true"
  ></app-bid-box-header>
  <app-bid-box-header
    *ngIf="!isMemorabid"
    [isGoldAuction]="false"
    [isSuggestedAuction]="true"
  ></app-bid-box-header>

  <app-carousel [value]="auctionSuggestions">
    <ng-template let-auction pTemplate="item">
      <!-- classi necessarie per permettere l'espansione sull'hover -->
      <div class="mx-1 py-3 element-dimensions">
        <app-bid-element [auction]="auction"></app-bid-element>
      </div>
    </ng-template>
  </app-carousel>

</div>
